module.exports = __webpack_public_path__ + "img/success-tick.7401037d.svg";